module.exports = __webpack_public_path__ + "img/selected3-min.20f6fc2e.png";